import React from "react";
import SectionShell from "./SectionShell";

export default function ForWhomSection() {
  return (
    <SectionShell
      id="kinek"
      testId="forwhom-section"
      eyebrow="Találkozás önmagaddal"
      titleStart=""
      titleAccent="Kinek"
      titleEnd=" szól?"
    >
      {/* Soft intro panel — subtle "not for" framing, never salesy */}
      <aside
        data-testid="forwhom-intro"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-7 md:py-8"
      >
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center">
          Nem annak szól, aki gyors megoldást keres, a másikat szeretné megváltoztatni,
          vagy bizonyítani akarja, hogy igaza van.
        </p>
      </aside>

      {/* Body prose — flowing, justified, book-like */}
      <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center my-8 md:my-10">
        Hanem annak, aki hajlandó ránézni a saját működésére.
      </p>

      <p>
        Annak, aki egy ideje érzi, hogy ugyanazok a helyzetek más-más formában újra és újra
        visszatérnek az életében. Aki már nem csak a válaszokat keresi, hanem nyitott arra is,
        hogy meglássa a történetek mögött rejlő mintákat és nézőpontokat, melyek automatikusan
        alakítják a döntéseit, a kapcsolatait és az életét. Annak, aki kész őszintén
        találkozni önmagával. Nem azért, hogy hibást keressen. Hanem hogy felismerje a saját
        szerepét mindabban, amit megél, és ezzel együtt a saját lehetőségeit is.
      </p>

      {/* Centered emphatic highlight */}
      <div className="my-8 md:my-10 text-center">
        <p className="font-serif-display italic text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-graphite max-w-xl mx-auto">
          Több lehetőség van benned annál,
          <br />
          mint amennyit <span className="text-gold">jelenleg látsz.</span>
        </p>
      </div>

      {/* Closing — flowing body, continuous with prior thought */}
      <p>
        Annak, aki nem tökéletesebb szeretne lenni, hanem{" "}
        <span className="text-gold">szabadabb</span>. Ezáltal egyre kevésbé
        beleszorulni azokba a történetekbe, amelyeket eddig valóságnak hitt.
      </p>
    </SectionShell>
  );
}
